(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/emp-video-player/assets/javascripts/helpers/setup-header.js') >= 0) return;  svs.modules.push('/components/components/emp-video-player/assets/javascripts/helpers/setup-header.js'); 'use strict';


const registerHeaderComponents = () => {
  const Button = empPlayer.videojs.getComponent('Button');
  const Component = empPlayer.videojs.getComponent('Component');
  const HeaderButton = empPlayer.videojs.extend(Button, {
    constructor: function (player, options) {
      Button.apply(this, arguments);
      const headerButton = options.headerButton;
      this.customOnClick = headerButton.customOnClick;
      this.addClass('icon');
      this.addClass(headerButton.icon);
      this.controlText(headerButton.controlText);

      if (headerButton.customClass) {
        this.addClass(headerButton.customClass);
      }
    },
    handleClick: function () {
      this.customOnClick();
    }
  });
  const TitleBar = empPlayer.videojs.extend(Component, {
    constructor: function (player, options) {
      Component.apply(this, arguments); 

      if (options.text) {
        this.updateTextContent(options.text);
      }
    },
    createEl: function () {
      return empPlayer.videojs.dom.createEl('div', {
        className: 'vjs-title-bar'
      });
    },
    updateTextContent: function (text) {
      if (typeof text !== 'string') {
        text = ' ';
      }

      empPlayer.videojs.dom.emptyEl(this.el());
      empPlayer.videojs.dom.appendContent(this.el(), text);
    }
  });
  empPlayer.videojs.registerComponent('TitleBar', TitleBar);
  empPlayer.videojs.registerComponent('HeaderButton', HeaderButton);
};

const setupHeader = options => {
  const player = options.player; 

  player.removeChild('TitleBar');
  player.removeChild('HeaderButton');

  if (options.headerButton) {
    player.addChild('HeaderButton', {
      headerButton: options.headerButton
    });
  }

  if (options.headerInfo) {
    player.addChild('TitleBar', {
      text: options.headerInfo
    });
  }
};

svs.components.emp_video_player.helpers.setupHeader = {
  setupHeader: setupHeader,
  registerHeaderComponents: registerHeaderComponents
};
 })(window);